import HelpPageFooterNotice from '../components/helpPageFooterNotice';
import React from 'react';

const AccountSettingsHelp = () => (
  <>
    <h1>Trip Alert Branding</h1>
    <p>
      As an account administrator, you are able to add or replace a graphic that
      appears on pages your travelers will see when registering their traveler
      profile, logging into to view their traveler profile, and editing their
      traveler profile.
    </p>
    <p>
      <strong>Guidelines:</strong>
    </p>
    <p>Images should look good on both a white and dark background.</p>
    <p>Images with transparent backgrounds tend to look more professional.</p>
    <p>An aspect ratio of 16:9 or 3:2 will be well proportioned.</p>
    <p>
      <strong>Instructions:</strong>
    </p>
    <p>
      To add or update an image, drag and drop a JPEG or PNG image into the
      "Header Image" box. Alternatively click "Upload New Image" to find an
      image file on your system.
    </p>
    <p>
      An image preview will appear if successful. Otherwise you will be prompted
      to provide a qualifying file.
    </p>
    <p>
      You can see a preview of your image as it will appear to your travelers by
      clicking on the following:
    </p>
    <ul>
      <li>Register Page</li>
      <li>Login Page</li>
      <li>Profile Page.</li>
    </ul>
    <p>Click "Save" when you are satisfied with the image you uploaded.</p>
    <HelpPageFooterNotice />
  </>
);

export default AccountSettingsHelp;
